import {AuditInfo} from '@frontend/shared-api';

export function latestAuditInfo(candidates: (AuditInfo | null | undefined)[]): AuditInfo | null {
  return candidates.reduce<AuditInfo | null>((latest, audit) => {
    if (!audit) return latest;
    if (!latest) return audit;
    return Date.parse(audit.lastUpdatedAt) > Date.parse(latest.lastUpdatedAt) ? audit : latest;
  }, null);
}
